var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedalBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.167 1.583)",
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4884E8",
    d: "M4.6 5.405 7.758 0h4.585L9.185 5.405z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6BA3FF",
    d: "m0 0 3.157 5.405h4.585L4.585 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FA9920",
    cx: 6.171,
    cy: 10.008,
    r: 5.825
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFBF4C",
    cx: 6.171,
    cy: 10.008,
    r: 4.604
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FA9920",
    cx: 6.171,
    cy: 10.008,
    r: 3.485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03 11.93c.265 0 .496-.031.691-.092.196-.06.358-.144.487-.253a1.01 1.01 0 0 0 .287-.382 1.22 1.22 0 0 0 .093-.48c0-.262-.082-.47-.246-.624-.164-.155-.406-.252-.725-.291V9.79c.12-.028.233-.07.337-.125.104-.055.194-.124.27-.206a.924.924 0 0 0 .248-.656.833.833 0 0 0-.093-.4.848.848 0 0 0-.264-.294 1.268 1.268 0 0 0-.41-.184 2.39 2.39 0 0 0-.919-.034 2.158 2.158 0 0 0-.629.206c-.09.046-.172.098-.247.154l.422.557c.043-.03.091-.062.145-.093a1.33 1.33 0 0 1 .384-.152c.075-.017.155-.025.242-.025.19 0 .328.04.415.119.088.08.132.19.132.33 0 .077-.014.15-.041.219a.427.427 0 0 1-.14.18.74.74 0 0 1-.263.122c-.11.03-.248.044-.414.044h-.276v.588h.281c.177 0 .326.012.447.037.12.026.218.061.293.107a.424.424 0 0 1 .213.389.706.706 0 0 1-.04.24.438.438 0 0 1-.13.187.642.642 0 0 1-.247.122 1.458 1.458 0 0 1-.387.043 2.021 2.021 0 0 1-.514-.066c-.09-.023-.18-.05-.27-.083a1.946 1.946 0 0 1-.258-.113v.711c.163.073.338.126.525.161.188.036.388.053.6.053z",
    fill: "#A66400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalBronze);
export default __webpack_public_path__ + "static/media/medal-bronze.37f09a94.svg";
export { ForwardRef as ReactComponent };